import { AiAssistantService } from './ai-assistant.service'

export const aiAssistantService = new AiAssistantService()
